import { injectable } from "@launchtray/tsyringe-async";
import { Event } from "event-system";

@injectable()
export class InfoModel {
    private currentPageIndex: number;
    public get CurrentPageIndex(): number {
        return this.currentPageIndex;
    }
    public set CurrentPageIndex(value) {
        this.previousPageIndex = this.currentPageIndex;
        this.currentPageIndex = value;
        this.onChange.emit();
    }

    private previousPageIndex: number;
    public get PreviousPageIndex(): number {
        return this.previousPageIndex;
    }

    private readonly totalPages: number;
    public get TotalPages(): number {
        return this.totalPages;
    }

    public readonly onChange: Event<void>;

    public constructor() {
        this.onChange = new Event<void>();
        this.currentPageIndex = 0;
        this.previousPageIndex = 1;
        this.totalPages = 2;
    }

    public nextPage(): void {
        if (this.currentPageIndex < this.totalPages - 1) {
            this.CurrentPageIndex++;
        }
    }

    public previousPage(): void {
        if (this.currentPageIndex > 0) {
            this.CurrentPageIndex--;
        }
    }

    public isLastPage(): boolean {
        return this.currentPageIndex == this.totalPages - 1;
    }

    public isFirstPage(): boolean {
        return this.currentPageIndex == 0;
    }
}